export default "__VITE_ASSET__B5s4FxyN__"